const choices = {
    '0-1': 'Moins de 1 an',
    '1-3': 'Entre 1 et 3 ans',
    '3-5': 'Entre 3 et 5 ans',
    '5+': 'Entre 5 et 8 ans',
    '8+': 'Plus de 8 ans',
};

export default choices;
